let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("idBCe")).then(() => parcelRequire('hyM6F'));